// constants for recaptcha
export const RECAPTCHA_API_KEY =
  window.location.host === 'www.asda.com'
    ? '6Ld16ygUAAAAAKAjn1fCN-aWh3PPEM0jv7tK4dPu'
    : '6Lem7igUAAAAAHxNjIZyzZ9gX6VvWl4t-fE5Eizg'
export const ALLOWED_THIRD_PARTIES = ['msm', 'whisk', 'apg', 'voice', 'giftcards', 'creditcard','ssomobile']
export const ALLOWED_THIRD_PARTY_CLIENT_IDS = [
  'd6ac62d9-f36f-45bb-ae2c-f6379c1e6330', // Gift Card non_prod
  '693842ee-c6e4-40e0-8551-7c883a48b650', // GiftCard prod
  'de852752-df7c-448e-ab38-ee154be80d22', // Summer Days non_prod
  '3d1656fb-fe1b-437e-a881-ef5a33026353', // Summer Days prod
  '664d7a5f-fcc5-4fef-a13d-26909c53e89c', // Whisk
  '38448084-9566-4731-a09a-cc0b166c658e', // ASDA Credit Card non_prod
  '94ac2bb2-066a-48d6-b380-2b9e05b4cdef', // ASDA Credit Card prod
 '8a486019-f5eb-4941-8640-4fc724d8b0d9', // ASDA Mobile SSO
 '4b9cd5cd-280b-4b5c-92e2-178c14ba032b', // SSO mobile prod
]
export const POSTCODE_REG_WHITE_LIST = ['scanandgo', 'george', 'asda', 'btc', 'giftcards', 'creditcard','ssomobile']
